import type { BaseRecord, ResourceProps } from "@refinedev/core";
import type { TableProps } from "antd";
import { Empty } from "antd";

export const APP_RESOURCE = [
  { name: "index", list: "/" },
  {
    name: "dashboard",
    list: "/dashboard",
    meta: {
      label: "property_information",
      icon: false,
    },
  },
  {
    name: "todo_management",
    list: "/todo_management",
    meta: {
      label: "todo_management",
      icon: false,
    },
  },
  {
    name: "todo_management",
    list: "/todo_management/completed",
    meta: {
      label: "todo_completed",
      icon: false,
    },
  },
  {
    name: "delivery",
    list: "/delivery-settings",
    meta: {
      icon: false,
      label: "delivery_provider_management",
    },
  },
  // {
  //   name: "entrance_configure",
  // },
  // {
  //   name: "stranded_list",
  //   list: "/strandedList",
  //   show: "/objects-list/:id",
  //   create: "/objects-list/create",
  //   edit: "/objects-list/edit/:id",
  //   meta: {
  //     parent: "entrance_configure",
  //   },
  // },

  // customer_configure
  {
    name: "customer_group_management_shareoffice",
    list: "/customer-configure/shareoffice",
    edit: "/notification-setting/shareoffice",
    meta: {
      icon: false,
      label: "customer_group_management_shareoffice",
    },
  },
  {
    name: "customer_group_management_mansion",
    list: "/customer-configure/mansion",
    edit: "/notification-setting/mansion",
    meta: {
      icon: false,
      label: "customer_group_management_mansion",
    },
  },
  // devices
  {
    name: "devices",
    list: "/devices-config",
    meta: {
      icon: false,
      label: "device_management",
    },
  },
  {
    name: "PabbitLite",
    list: "/devices-config/lite",
    meta: {
      label: "Pabbit Lite",
      parent: "devices",
    },
  },
  {
    name: "dearis",
    list: "/devices-config/dearis",
    meta: {
      label: "dearis",
      parent: "devices",
    },
  },
  {
    name: "dearis+",
    list: "/devices-config/dearis+",
    meta: {
      label: "dearis+",
      parent: "devices",
    },
  },
  {
    name: "PATMO",
    list: "/devices-config/patmo",
    meta: {
      label: "PATMOα",
      parent: "devices",
    },
  },
  {
    name: "locker",
    list: "/devices-config/locker",
    show: "/devices-config/locker/:deviceId",
    meta: {
      label: "Pabbit Locker",
      parent: "devices",
    },
  },
  {
    name: "Notify",
    list: "/devices-config/notify",
    meta: {
      label: "Notify",
      parent: "devices",
    },
  },
  // temp_access
  {
    name: "temp_access",
    list: "/temporary-access",
    meta: {
      icon: false,
    },
  },
  {
    name: "bizkey",
    meta: {
      icon: false,
    },
  },
  {
    name: "bizkey_approval",
    list: "/bizkey/approval",
    show: "/bizkey/approval/:id",
    meta: {
      parent: "bizkey",
    },
  },
  {
    name: "account_management",
    list: "/property-personnel",
    meta: {
      icon: false,
      label: "account_management",
    },
  },
  {
    name: "user_detail",
    list: "/property-personnel/user/:id",
    meta: {
      icon: false,
      label: "user_detail",
    },
  },
  // {
  //   name: "temp_access_configure",
  //   list: "/tempAccessConfigure",
  // },
  // {
  //   name: "lockers_configure",
  // },
  // {
  //   name: "lockers_list",
  //   list: "/lockersConfigure/lockers",
  //   show: "/lockersConfigure/lockers/:id",
  //   meta: {
  //     parent: "lockers_configure",
  //   },
  // },
  // {
  //   name: "parcel_locker_list",
  //   list: "/lockersConfigure/parcelLockers",
  //   meta: {
  //     parent: "lockers_configure",
  //   },
  // },
  // { name: "residential_configure", list: "/residentialConfigure" },
  // {
  //   name: "system_configure",
  // },
  // {
  //   name: "accounts_manage",
  //   list: "systemConfigure/accounts",
  //   meta: {
  //     parent: "system_configure",
  //   },
  // },
  // {
  //   name: "subscriptions_manage",
  //   list: "/systemConfigure/subscriptions",
  //   meta: {
  //     parent: "system_configure",
  //   },
  // },
] satisfies ResourceProps[];

export const TABLE_PROPS = {
  pagination: { position: ["bottomCenter"] },
  rowKey: "id",
  scroll: { x: "max-content" },
  locale: {
    emptyText: <Empty className="h-full" description="情報がありません。" image={Empty.PRESENTED_IMAGE_SIMPLE} />,
  },
} satisfies TableProps<BaseRecord>;
